<template>
  <div>
    <!-- Total solicitudes registradas -->
    <TotalComplaints
      :styleWidth="'w-80'"
      :total="count"
      title="Total de solicitudes"
      body="solicitudes"
    />

    <!-- Filtro de busqueda de solicitudes -->
    <TecnicalSupportFilter
      :loading="loading"
      :searching="searching"
      @getFilterForm="setFilterForm"
    />

    <!-- Tabla de datos de solicitudes -->
    <TecnicalSupportTable :dataSource="technicalSupports" />

    <div class="p-4 flex justify-end">
      <a-pagination
        v-model="page"
        :page-size="pageSize"
        :page-size-options="pageSizeOptions"
        :total="count"
        show-size-changer
        size="large"
        @showSizeChange="onShowSizeChange"
        @change="onChange"
      />
    </div>
  </div>
</template>

<script>
import TecnicalSupportFilter from "../partials/TecnicalSupportFilter.vue";
import TecnicalSupportTable from "../partials/TecnicalSupportTable.vue";
import TotalComplaints from "../../../../components/Dashboard/Complaints/TotalComplaints.vue";
import SupportStatusLabel from "../partials/SupportStatusLabel.vue";
import SupportTypeProblemLabel from "../partials/SupportTypeProblemLabel.vue";
import supportServiceImplementation from "@/feature/tecnical_support/data/services/tecnical_support_services_impl";
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
} from "../../../../core/utils/constants";

export default {
  components: {
    TotalComplaints,
    TecnicalSupportFilter,
    TecnicalSupportTable,
    SupportStatusLabel,
    SupportTypeProblemLabel,
  },
  data() {
    return {
      count: 0,
      loading: false,
      form: {},
      page: DEFAULT_PAGE,
      pageSize: DEFAULT_PAGE_SIZE,
      pageSizeOptions: ["50", "100", "150", "200", "250"],
      searching: false,
      technicalSupports: [],
    };
  },
  methods: {
    async setFilterForm(form, pagination) {
      this.form = form;
      if (pagination.page && pagination.pageSize) {
        this.page = pagination.page;
        this.pageSize = pagination.pageSize;
      }
      await this.fetchData();
    },

    async fetchData() {
      this.loading = true;
      this.searching = true;
      const pagination = {
        page: this.page,
        pageSize: this.pageSize,
      };
      try {
        const { data } = await supportServiceImplementation.getTecnicalSupport(
          pagination,
          this.form
        );
        this.setDeafultEmited(data);
      } catch (error) {
        this.setDeafultEmited(null);
      } finally {
        this.loading = false;
        this.searching = false;
      }
    },
    setDeafultEmited(resp) {
      this.count = resp?.count || 0;
      const data = resp?.results || [];

      if (data.length > 0) {
        this.technicalSupports = data.map((element) => {
          // The 'T' is replaced by a space for better readability in the table.
          const formattedDate = element.creation_date.replace("T", " ");
          return {
            ...element,
            creation_date: formattedDate,
          };
        });
      } else {
        this.technicalSupports = [];
      }
    },
    // Cambio de tamaño de página
    onShowSizeChange(page, page_size) {
      // Ante el cambio en el tamaño de la pagina se debe reiniciar la página a 1
      this.page = 1;
      this.pageSize = page_size;
      this.fetchData();
    },
    // Cambio de página
    onChange(page, page_size) {
      this.page = page;
      this.pageSize = page_size;
      this.fetchData();
    },
  },
};
</script>

<style></style>
